import { configureGaplessAxisSafety } from './gaplessAxisSafety';
const legends = new WeakSet();
const panels = new WeakSet();
export function configureStockLegendCleanup(legend) {
  if (legends.has(legend)) return;
  legends.add(legend);
  const original = legend.disposeDataItem;
  legend.disposeDataItem = function (item) {
    // Direct Indicator.dispose must use the data list so source/items stay aligned.
    // During normal list removal the item is already disposed; let that outer
    // removal own its splice, otherwise the following indicator gets removed too.
    if (!item.isDisposed?.() && this.data && this.dataItems) {
      const index = this.dataItems.indexOf(item);
      if (index !== -1 && this.data.values[index] === item.dataContext) {
        this.data.removeIndex(index);
        return;
      }
    }
    // StockLegend leaves its extra button-list entries behind on item removal.
    for (const [key, list] of [['settingsButton', this.settingsButtons], ['closeButton', this.closeButtons]]) {
      const button = item.get(key);
      if (button) list?.removeValue(button);
    }
    return original.call(this, item);
  };
}
export function configureStockAxisCleanup(stockChart, panel) {
  if (panels.has(panel)) return;
  panels.add(panel);
  // Installed StockChart._removeXAxis is empty; prune the sync registry on disposal.
  const watchedAxes = new WeakSet();
  const watch = axis => {
    if (watchedAxes.has(axis)) return;
    watchedAxes.add(axis);
    configureGaplessAxisSafety(axis);
    axis.addDisposer({ dispose() {
    // Disposing an axis directly does not remove it from its panel's list.
    // ListAutoDispose.dispose iterates the live array. Removing an item there
    // skips the next axis and can make that loop read beyond the shortened array.
    if (!panel.xAxes.isDisposed?.()) panel.xAxes.removeValue(axis);
    const axes = stockChart._xAxes;
    if (!Array.isArray(axes)) return;
    const index = axes.indexOf(axis);
    if (index !== -1) axes.splice(index, 1);
    }});
  };
  panel.xAxes.each(watch);
  for (const type of ['push', 'insertIndex', 'setIndex']) {
    panel.addDisposer(panel.xAxes.events.on(type, event => watch(event.newValue)));
  }
}
